import { useEffect, useState } from "react";
import { loadCatalog, loadFolders, previewError } from "../api/reports";
import type { PreviewCatalog, PreviewFilters, PreviewFolder } from "../types";

export function useReportCatalog(filters: PreviewFilters) {
    const [catalog, setCatalog] = useState<PreviewCatalog>({ items: [], total: 0 });
    const [folders, setFolders] = useState<PreviewFolder[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [attempt, setAttempt] = useState(0);
    const filterKey = JSON.stringify(filters);
    useEffect(() => {
        const controller = new AbortController();
        const timer = window.setTimeout(() => loadFolders(controller.signal).then(result => {
            if (!controller.signal.aborted) setFolders(result);
        }).catch(async e => {
            const message = await previewError(e);
            if (!controller.signal.aborted) setError(message);
        }), 0);
        return () => { window.clearTimeout(timer); controller.abort(); };
    }, [attempt]);
    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        setError("");
        const timer = window.setTimeout(async () => {
            try {
                const result = await loadCatalog(JSON.parse(filterKey), controller.signal);
                if (!controller.signal.aborted) setCatalog(result);
            } catch (e) {
                const message = await previewError(e);
                if (!controller.signal.aborted) setError(message);
            } finally { if (!controller.signal.aborted) setLoading(false); }
        }, 250);
        return () => { window.clearTimeout(timer); controller.abort(); };
    }, [filterKey, attempt]);
    return { catalog, folders, loading, error, retry: () => setAttempt(n => n + 1) };
}
